module.exports = __webpack_public_path__ + "static/img/jigou-4-top.5795f04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-4-top.png
// module id = yj+I
// module chunks = 2